module.exports = __webpack_public_path__ + "static/media/Q1-8.29dd4688.jpg";